import styles from '../emergencyAlert.module.css';
import AIEduDropDown from '../../../components/DropDown/AIEduDropDown';

const ColorPicker = ({
    label,
    selectedColor,
    onColorChange,
    colorOptions,
    selectedColorTemplate,
    colorItemTemplate,
    f
}) => {
    return (
        <div className='flex justify-content-between mt-4 mb-4'>
            <div className={styles.emergency_alert_colorLabelTextStyle}>
                {label}
            </div>
            <AIEduDropDown
                value={selectedColor}
                onChange={onColorChange}
                options={colorOptions}
                optionLabel='name'
                placeholder={f({ id: 'AI_EDU_SELECT_COLOR' }, { color: label.toLowerCase() })}
                className={
                    styles.color_dropdown + ' w-full md:w-14rem'
                }
                valueTemplate={selectedColorTemplate}
                itemTemplate={colorItemTemplate}
            />
        </div>
    );
};

export default ColorPicker;
